<template>
  <div class="container">
    <h4>评价运营设置</h4>
    <div class="list">
      <div v-for="(item, index) in ruleList" :key="index" class="list-item">
        <div>
          <span class="label" style="margin-right: 20px">{{item.platform}}</span>
          <span class="label">奖励类型</span>
<!--          <el-switch-->
<!--              style="margin-right: 10px"-->
<!--              v-model="item.type"-->
<!--              :active-value="1"-->
<!--              :inactive-value="2"-->
<!--              active-color="#13ce66"-->
<!--              inactive-color="#ff4949"-->
<!--              active-text="券码"-->
<!--              inactive-text="现金">-->
<!--          </el-switch>-->
          <el-select v-model="item.type" placeholder="请选择" style="width: 100px; margin-right: 10px" size="small">
            <el-option label="无奖项" :value="0"></el-option>
            <el-option label="券码" :value="1"></el-option>
            <el-option label="现金" :value="2"></el-option>
          </el-select>
          <span v-if="item.type === 1" style="margin-right: 10px">
            <span class="label">券ID</span>
            <el-input
                size="small"
                type="number"
                v-model="item.couponId"
                placeholder="请输入券码ID"
                class="input"
                @input="validateNumber(item, 'couponId')"
            >
            </el-input>
          </span>
          <span v-if="item.type === 2" style="margin-right: 10px">
            <span class="label">现金</span>
            <el-input
                size="small"
                v-model="item.money"
                placeholder="请输入现金（如1~5或者5）"
                class="input"
            >
            </el-input>
          </span>

          <span class="label">适用门店</span>
          <el-select size="small" v-model="item.storeIds" placeholder="请选择适用门店" multiple filterable
                     clearable style="width: 300px; margin-right: 20px">
            <el-option-group
                v-for="group in stores"
                :key="group.label"
                :label="group.label">
              <el-option
                  v-for="item in group.options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-option-group>
          </el-select>

          <span class="label">状态</span>
          <el-switch v-model="item.status" :active-value="1" :inactive-value="0"></el-switch>
        </div>
      </div>
    </div>

    <el-button
        type="primary"
        class="save-btn"
        @click="handleSave"
        :loading="saving"
    >保存
    </el-button>
  </div>
</template>

<script>


export default {
  data() {
    return {
      /*门店列表*/
      stores: [],
      ruleList: [],
      saving: false
    }
  },
  mounted() {
    this.fetchStore()
    this.handleGetConfig()
  },
  methods: {
    fetchStore() {
      this.$http.get("store/list").then(({data}) => {
        let storesBusiness = []
        let storesEnd = []
        data.data.forEach(ele => {
          const val = {value: ele.id, label: ele.title};
          if (ele.businessType === 1) {
            storesEnd.push(val) //结业门店
          } else {
            storesBusiness.push(val) //营业门店
          }
        })
        this.stores = [
          {
            label: '营业门店',
            options: storesBusiness
          },
          {
            label: '结业门店',
            options: storesEnd
          },
        ]
      })
    },
    // 获取配置
    handleGetConfig() {
      this.$http.get("market/review").then(({data}) => {
        this.ruleList = data.data.ruleList
      })
    },

    // 验证数字输入
    validateNumber(item, field) {
      if (item[field] < 0) {
        item[field] = 0;
      }
      // 确保是整数
      item[field] = Math.floor(item[field]);
    },

    // 保存设置
    handleSave() {
      // 验证数据
      for (let i = 0; i < this.ruleList.length; i++) {
        const item = this.ruleList[i];

        if (item.status === 1 && item.type === 1 && !item.couponId) {
          this.$message.error(`请填写${item.platform}的券码ID`);
          return;
        }

        if (item.status === 1 && item.type === 2 && !item.money) {
          this.$message.error(`请填写${item.platform}的现金`);
          return;
        }

        if (item.status === 1 && !item.storeIds) {
          this.$message.error(`请填写${item.platform}的适用门店`);
          return;
        }
      }
      this.saving = true;
      this.$http.post("market/review", JSON.stringify({
        ruleList: this.ruleList
      })).then(({data}) => {
        this.saving = false;
        this.$message.success('保存成功');
      })
    }
  }
}
</script>

<style scoped>
.container {
  max-width: 1000px;
  margin: 0 auto;
  padding: 20px;
}

h4 {
  margin: 20px 0 15px;
  color: #333;
  font-size: 16px;
}

.list-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
  padding: 15px;
  background: #f9f9f9;
  border-radius: 4px;
}

.radio {
  margin-right: 15px;
}

.input {
  width: 180px;
  margin-right: 15px;
}

.ratio-label, .label {
  margin-right: 10px;
  color: #606266;
  font-size: 14px;
  font-weight: 500;
}

.delete-btn {
  float: right;
}

.add-btn {
  margin: 10px 0;
  color: #409EFF;
}

.save-btn {
  display: block;
  margin: 50px auto 0;
  width: 200px;
}
</style>
